<template>
    <div id="new_label" class="fields">
        <div class="fields">
            <PrintingType
                :printing_type="current_printing_type"
                :channel="channels.printing_type"
                :scope="scope">
            </PrintingType>
            <PaperSize
                :paper_size="current_paper_size"
                :channel="channels.paper_size"
                :scope="scope">
            </PaperSize>
            <Template
                :template="current_template"
                :channel="channels.template">
            </Template>
            <div v-if="!errors" class="field">
                <label>&emsp;</label>
                <div class="ui button"
                    :class="{
                        loading: is_printing
                    }"
                    :disabled="!is_printing"
                    @click.prevent="add_image_print_job()">
                    {{ $t('ui.toolbox.core_waybills_label_svg.btns.print') }}
                </div>
                <i>({{ src_array.length }}/{{ numbers.length }})</i>
            </div>
            <slot name="button"></slot>
        </div>
    </div>
</template>

<script>
import PrintingType from './new_label_tool/printing_type.vue'
import PaperSize from './new_label_tool/paper_size.vue'
import Template from './new_label_tool/template.vue'

export default {
    name: "ToolCoreWaybillsLabelSvgNewLabel",
    components: {
        PrintingType,
        PaperSize,
        Template,
    },
    props: {
        numbers: {
            type: Array,
            default: []
        },
        printing_type: {
            type: String,
            default: ""
        },
        paper_size: {
            type: String,
            default: "A4"
        },
        template: {
            type: String,
            default: "1x1"
        },
        label_type: {
            type: String,
            default: ""
        },
        authentication_token: {
            type: String,
            default: ""
        },
        staff_identity: {
            type: String,
            default: ""
        },
        is_show_input: {
            type: Boolean,
            default: true,
        },
        scope: {
            type: String,
            default: "provider"
        },
        node_carrier_name: {
            type: String,
            default: ""
        },
        is_post_method: {
            type: Boolean,
            default: false
        },
        channel: String,
    },
    data() {
        return {
            is_initialized: false,
            is_processing: true,
            is_printing: false,
            post_method: {
                url: "",
                numbers: ""
            },
            errors: "",
            src_array: [],
            current_numbers: "",
            current_printing_type: "",
            current_paper_size: "",
            current_template: "",
            channels: {
                printing_type: "printing_type_channel",
                paper_size: "paper_size_channel",
                template: "template_channel",
            }
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.init()

        this.$bus.$on('print_done_signal', () => {
            this.is_printing = false
        })
    },
    watch: {
    },
    methods: {
        async init() {
            this.src_array = []
            this.is_processing = true

            await this.check_props()
            await this.set_channels("printing_type")
            await this.set_channels("paper_size")
            await this.set_channels("template")
            await this.clone_paper()
            await this.init_paper_size()
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        set_channels(key_name) {
            let channel_name = this.channels[key_name]
            this.$bus.$off(channel_name)
            this.$bus.$on(channel_name, value => {
                this["current_"+key_name] = value
            })
            return Promise.resolve()
        },
        clone_paper () {
            this.current_printing_type = _.clone(this.printing_type)
            this.current_paper_size = _.clone(this.paper_size)
            this.current_template = _.clone(this.template)
            return Promise.resolve()
        },
        init_paper_size () {
            try {
                if (this.current_printing_type == "") throw "not printing_type"
                let height = 100
                let width = 100

                if (this.current_printing_type.match(/PrescoInvoice|FamilyMartInvoice/)) {
                    height = 200
                    width = 100
                }

                if (this.current_printing_type.match(/TCat/)) {
                    height = 190
                    width = 95
                }

                if (this.current_printing_type.match(/FlyCargo|TCat180|Condor180/)) {
                    height = 180
                    width = 100
                }

                if (this.current_printing_type.match(/Pelican/)) {
                    height = 99
                    width = 210
                }

                this.current_paper_size = String(height) + "x" + String(width)
            } catch (e) {
                console.log(e)
            }
            return Promise.resolve()
        },
        async add_image_print_job () {
            if (!this.is_printing) {
                this.is_printing = true
                await this.handle_label()
                await new Promise(resolve => {
                    this.$bus.$emit('add_image_print_job',{
                        images: this.src_array,
                        paper_type: this.current_paper_size,
                        numbers_of_one_page: 1
                    })
                    resolve()
                })
            }
        },
        check_props () {
            this.errors = ""
            try {
                if (!this.authentication_token) {
                    // throw "pops 參數請給予 authentication_token"
                    throw this.$t('ui.toolbox.core_waybills_label_svg.errors.no_authentication_token')
                }

                var numbers = (this.numbers)
                    ? this.numbers
                    : this.current_numbers

                if (!numbers) {
                    // this.errors = "請輸入號碼"
                    this.errors = this.$t('ui.toolbox.core_waybills_label_svg.errors.no_number')
                }

            } catch (err) {
                this.errors = err
                this.$noty.error(err)
            }
            return Promise.resolve()
        },
        handle_label () {
            this.src_array = []
            let label_numbers = (this.numbers)
                ? this.numbers
                : this.current_numbers

            // remove null
            // let numbers_array = core_waybill_numbers.split(",")
            // _.remove(numbers_array, _.isUndefined)
            // numbers_array = _.filter(numbers_array)

            let template_x = 1
            let template_y = 1
            let template_result = this.current_template.match(/(\d+)x(\d+)/)
            if (template_result[1] && template_result[2]) {
                template_x = template_result[1]
                template_y = template_result[2]
            }

            let parameters = '.svg?paper_size='+this.current_paper_size+
                '&template='+this.current_template+
                '&authorization='+this.authentication_token


            let contents = []
            let numbers = []

            let base_url = this.handle_url() + parameters
            let one_page_count = template_x*template_y
            _.forEach(label_numbers, (label_number, index) => {
                numbers.push(label_number.number)
                var content = {
                    core_waybill_number: label_number.number,
                    printing_type: this.current_printing_type,
                    data: {
                        count: label_number.count,
                        serial: label_number.serial
                    }
                }
                if (this.staff_identity) {
                    content.staff_identity = this.staff_identity
                }
                contents.push(content)
                if (
                    ((index+1)%one_page_count == 0) ||
                    (label_numbers.length == index+1)
                ) {
                    let src = base_url + "&contents=" + JSON.stringify(contents) + "&v=" + Date.now().toString()
                    this.src_array.push({
                        name: numbers.toString(),
                        src: src.replace(/,"data":{}/g,'')
                    })
                    contents = []
                    numbers = []
                }
            })
            return Promise.resolve()
        },
        handle_url() {
            switch (this.scope) {
                case 'provider':
                    return this.$store.state.provider.routes.api_v1_provider_papers_print
                    break
                case 'customer':
                    return this.$store.state.customer.routes.api_v1_customer_papers_print
                    break

                default:
                    return this.$store.state.provider.routes.api_v1_provider_papers_print
            }
        },
    }
}
</script>

<style scoped lang="scss">
    .ui.form .fields {
        margin: 0;
    }
    #core_waybills_label_svg .labels {
        display: none;
    }
    img {
        padding: 0;
        margin: 0;
    }
</style>
